export const pickRandomListItem = <T>(list: T[]): T => {
  const index = Math.floor(Math.random() * list.length)
  return list[index]
}
